import { render, staticRenderFns } from "./ReturnLabelsModal.vue?vue&type=template&id=053aa52a&"
import script from "./ReturnLabelsModal.vue?vue&type=script&lang=js&"
export * from "./ReturnLabelsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports